import { apiSlice } from "./apiSlice";

export const teacherApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Get all teachers
		getTeachers: builder.query({
			query: () => "/Teacher",
			providesTags: ["Teachers"],
		}),

		// Get teacher by ID
		getTeacherById: builder.query({
			query: (id) => `/Teacher/${id}`,
			providesTags: (result, error, id) => [{ type: "Teachers", id }],
		}),

		// Create new teacher
		createTeacher: builder.mutation({
			query: (teacherData) => ({
				url: "/Teacher",
				method: "POST",
				body: teacherData,
			}),
			invalidatesTags: ["Teachers"],
		}),

		// Update teacher
		updateTeacher: builder.mutation({
			query: ({ id, ...teacherData }) => ({
				url: `/Teacher/${id}`,
				method: "PUT",
				body: teacherData,
			}),
			invalidatesTags: (result, error, { id }) => [
				"Teachers",
				{ type: "Teachers", id },
			],
		}),

		// Delete teacher
		deleteTeacher: builder.mutation({
			query: (id) => ({
				url: `/Teacher/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Teachers"],
		}),

		// Add subject to teacher
		addSubjectToTeacher: builder.mutation({
			query: ({ teacherId, subjectId, departmentIds }) => ({
				url: `/Teacher/${teacherId}/add-subject`,
				method: "POST",
				body: {
					SubjectId: subjectId,
					DepartmentId: departmentIds,
				},
			}),
			invalidatesTags: (result, error, { teacherId }) => [
				"Teachers",
				{ type: "Teachers", id: teacherId },
			],
		}),

		// Remove subject from teacher - FIX: Use correct endpoint
		removeSubjectFromTeacher: builder.mutation({
			query: ({ teacherId, subjectId }) => ({
				url: `/Teacher/${teacherId}/remove-subject/${subjectId}`,
				method: "DELETE",
			}),
			invalidatesTags: (result, error, { teacherId }) => [
				"Teachers",
				{ type: "Teachers", id: teacherId },
			],
		}),
	}),
});

export const {
	useGetTeachersQuery,
	useGetTeacherByIdQuery,
	useCreateTeacherMutation,
	useUpdateTeacherMutation,
	useDeleteTeacherMutation,
	useAddSubjectToTeacherMutation,
	useRemoveSubjectFromTeacherMutation,
} = teacherApiSlice;
